export const deviceTypeMap = [
    {
        value: 'JETSON_NX',
        gpu: true,
        i18nKey: 'device.jetsonnx'
    }
]